import { render, staticRenderFns } from "./activityLogItem.vue?vue&type=template&id=106f8f05&"
import script from "./activityLogItem.vue?vue&type=script&lang=js&"
export * from "./activityLogItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports